export const USER_POSITION_LABELS = {
  userPositions: 'userPositions',
  positionName: 'name',
};
